export default __webpack_public_path__ + "static/Other-Building-Demolition-d960cd26a39808c48da07dab87817170.jpg";